export default __webpack_public_path__ + "static/media/arrow-right.1d4872d8.svg";